import { AppRoutes } from "../../Core/App/AppRoutes";
import { getAuthRoutes } from "./Routes/AuthRoutes";
import {getWorkerRoutes} from "./Routes/WorkerRoutes";

export const DEFAULT_ROOT = AppRoutes.LOGIN;

export const getAppRoutes = () => [
    ...getAuthRoutes(),
    ...getWorkerRoutes({}),
];